import { EPropertyGuidesGroups } from '../../shared/utils/ab_mainpage_property_guides';
import { FDealType } from '../../shared/utils/category';
import { SearchType } from '../types/filters/type';

/**
 * @property oldSearchType - тип для старых фильтров (комопнент TypeFilter).
 * Рендерим PropertyGuides, если тип равен "Купить".
 *
 * @property newSearchType - тип для новых фильтров (компонент FiltersTabs).
 * Рендерим PropertyGuides, если тип равен "Купить".
 */
interface IFilters {
  isNewFiltersVisible: boolean;
  oldSearchType: SearchType;
  newSearchType: FDealType;
}

interface IParams {
  filters: IFilters;
  subdomain: string;
  section: string;
  experimentGroup: EPropertyGuidesGroups;
}

export const shouldPropertyGuidesShow = ({
  filters: { isNewFiltersVisible, oldSearchType, newSearchType },
  subdomain,
  section,
  experimentGroup,
}: IParams): boolean => {
  const isGroupMatch = experimentGroup !== EPropertyGuidesGroups.Empty;
  const isSectionMatch = ['index', 'sale'].includes(section);
  const isSubdomainMatch = ['samara', 'nn'].includes(subdomain);
  const isSearchTypeMatch = isNewFiltersVisible ? newSearchType === FDealType.Sale : oldSearchType === 'buy';

  return isGroupMatch && isSectionMatch && isSubdomainMatch && isSearchTypeMatch;
};
